import { ReactElement } from 'react'
import { Button, Flex } from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'
import { PropsBookingReasonsTemplate } from './props'

const BookingReasonsTemplate = ({
    bookingReasons,
    selectedBookingReasons,
    onClickBookingReason,
}: PropsBookingReasonsTemplate): ReactElement => {
    const { t } = useTranslation()

    return (
        <Flex
            gap={4}
            css={{
                flexWrap: 'wrap',
            }}
        >
            {bookingReasons.map((reason, key) => (
                <Button
                    active={selectedBookingReasons
                        .map((r) => r.id)
                        .includes(reason.id)}
                    data-cy={`bookingReason_${key + 1}`}
                    key={key}
                    onClick={() => onClickBookingReason(reason)}
                    size="small"
                    variant="option"
                    rounded
                >
                    {t(`details.form.bookingreasons.options.${reason.id}`)}
                </Button>
            ))}
        </Flex>
    )
}

export default BookingReasonsTemplate
